const mediaUrl = (path) => {
  if (!path) return null;

  if (
    path.startsWith("http://") ||
    path.startsWith("https://") ||
    path.startsWith("/media/")
  ) {
    return path;
  }

  return `/media/${path.replace(/^\/+/, "")}`;
};

const applyVideoQualitySuffix = (url, suffix) => {
  if (!url) return url;

  const match = url.match(
    /^(.*?)(?:_(?:540|720|1080))?\.mp4([?#].*)?$/i,
  );
  if (!match) return url;

  const [, base, tail = ""] = match;
  return `${base}${suffix}.mp4${tail}`;
};

export const isMp4Media = (path) =>
  /\.mp4(?:[?#].*)?$/i.test(path || "");

export const responsiveVideoUrl = (path, viewportWidth = window.innerWidth) => {
  const url = mediaUrl(path);
  if (!url) return null;

  if (!isMp4Media(url)) return url;

  if (viewportWidth <= 700) return applyVideoQualitySuffix(url, "_540");
  if (viewportWidth <= 1200) return applyVideoQualitySuffix(url, "_720");
  return applyVideoQualitySuffix(url, "_1080");
};

export const resolvedMediaUrl = (path, viewportWidth = window.innerWidth) =>
  responsiveVideoUrl(path, viewportWidth);
